<script>
import {mapActions} from "vuex";
import EntryPatternBuilderMixin from "@/mixins/driver/entry-pattern-builder-mixin";

export default {
  name: "AddEntryPatternModal",
  mixins: [
    EntryPatternBuilderMixin
  ],
  props: {
    /**
     * 受注種別
     */
    orderType: {
      type: String,
      default: "collection"
    },
    /**
     * 排出事業者ID
     */
    emissionId: {
      type: Number,
      default: null
    },
    /**
     * 排出事業者名
     */
    emissionName: {
      type: String,
      default: null,
    },
    /**
     * 排出事業場ID
     */
    locationId: {
      type: Number,
      default: null
    },
    /**
     * 排出事業場名
     */
    locationName: {
      type: String,
      default: null,
    },
    /**
     * 受注
     */
    order: {
      type: Object,
      default: () => ({})
    },
    /**
     * スポット利用
     */
    isSpot: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    enable (newValue) {
      if (!newValue) {
        Object.assign(this.$data.form, this.$options.data().form);
        this.$nextTick(() => this.$refs.observer.reset())
      }
      if (newValue) {
        this.form.location_id = this.locationId;
        this.form.is_shared = false;
        if (this.isSpot || !this.locationId ) {
          this.form.is_shared = true;
        }
        this.labelLocationName = this.locationName;

      }
    },
  },
  computed: {
    disableAddEntryPattern () {
      return !(this.emissionId && this.order.form_type === 'master_mode')
    },
  },
  data () {
    return {
      enable: false,
      labelLocationName: null,
      form: {
        name: null,
        location_id: null,
        is_shared: false,
        sort_priority: null,
      }
    }
  },
  methods: {
    /**
     * 登録パターン
     */
    ...mapActions("DriverMasterEntryPattern", {
      createEntryPattern: "create",
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.enable = false;
    },
    /**
     * 登録ボタン クリックイベント
     */
    reflectionButtonClickEvent () {
      this.$refs.observer.validate().then((result) => {
        if(result) {
          this.register()
        }
      })
    },
    /**
     * パターンの登録処理
     */
    register () {
      let orderMember = this.entryPatternParameterBuilder(this.orderType, this.form.is_shared);
      if (this.form.is_shared) {
        this.form.location_id = null;
      }
      const parameters = {
        ...this.form,
        ...orderMember,
        order_type: this.orderType,
      };
      this.createEntryPattern({ params: parameters }).then((content) => {
        this.$emit("register:pattern", content);
        this.closeButtonClickEvent();
      })
    },
  }
}
</script>

<template>
  <v-dialog
    v-model="enable"
    width="650"
    scrollable
    persistent
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="disableAddEntryPattern"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        パターンに追加
      </v-btn>
    </template>
    <validation-observer
      v-if="enable"
      ref="observer"
      v-slot="{ invalid }"
    >
      <v-card flat>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>パターン登録</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container class="pa-0">
            <v-row>
              <v-col>
                <h3>受注種別:&nbsp;{{ orderType | short_order_type_label }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <div class="overline">
                  排出事業者
                </div>
                <h4 class="font-weight-medium">
                  <span>
                    {{ emissionName }}&nbsp;
                  </span>
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <div class="overline">
                  排出事業場
                </div>
                <h4 class="font-weight-medium">
                  <span v-if="form.is_shared">
                    -
                  </span>
                  <span v-else>
                    {{ labelLocationName }}&nbsp;
                  </span>
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="パターン名"
                  rules="required|max:25"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="form.name"
                    :error-messages="errors"
                    clearable
                    dense
                    label="パターン名"
                    hide-details="auto"
                    outlined
                    persistent-hint
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>パターン名</span>
                      <span class="ml-1">
                        ({{ form.name?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-checkbox
                  v-model="form.is_shared"
                  :disabled="isSpot || !locationId"
                  dense
                  label="事業場共通として利用する"
                  hide-details="auto"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="invalid"
            color="primary"
            @click="reflectionButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
